import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/site";

export default function NotFound() {
  usePageMeta("MAATTR", "");
  return (
    <div className="home" data-testid="not-found">
      <div className="door">
        <header className="name">MAATTR</header>
        <main>
          <h1 className="line">
            <span className="first">This page does not exist.</span>
            <Link className="is" to="/" data-testid="not-found-home-link">Return.</Link>
          </h1>
        </main>
      </div>
    </div>
  );
}
